import type {
  LocationCreateVariables,
  LocationEntity,
  LocationUpdateVariables,
} from "./location.type";
import type { UseCreateOptions, UseUpdateOptions } from "@/hooks/queries";
import type { Int } from "@/types";

import { useCreate, useUpdate } from "@/hooks/queries";

export const useCreateLocation = (
  options?: UseCreateOptions<LocationEntity, LocationCreateVariables>
) => {
  return useCreate<LocationEntity, LocationCreateVariables>(
    "locations",
    options
  );
};

export const useUpdateLocation = (
  locationId: Int,
  options?: UseUpdateOptions<LocationEntity, LocationUpdateVariables>
) => {
  return useUpdate<LocationEntity, LocationUpdateVariables>(
    "locations",
    locationId,
    options
  );
};
